import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { DynamicIcon } from 'src/components';
import type { PreviewViewport } from 'src/store/memberships-config';

/** Material Symbols ligature names. `library="lucide"` would need these in its allowlist. */
const VIEWPORTS: { value: PreviewViewport; label: string; icon: string }[] = [
  { value: 'desktop', label: 'Desktop', icon: 'monitor' },
  { value: 'mobile', label: 'Mobile', icon: 'smartphone' },
];

type PreviewViewportToggleProps = {
  value: PreviewViewport;
  onChange: (viewport: PreviewViewport) => void;
};

export const PreviewViewportToggle = ({ value, onChange }: PreviewViewportToggleProps) => (
  <ToggleButtonGroup
    exclusive
    size="small"
    value={value}
    onChange={(_, next: PreviewViewport | null) => {
      if (next) {
        onChange(next);
      }
    }}
    aria-label="Preview viewport"
  >
    {VIEWPORTS.map((viewport) => (
      <ToggleButton key={viewport.value} value={viewport.value} aria-label={viewport.label}>
        <DynamicIcon name={viewport.icon} sx={{ fontSize: '1.125rem' }} />
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);
